import React from "react";
import PropTypes from "prop-types";
import { inlineElements, generateStyle, setOverLay, l } from "../../functions";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import state from "../../state";
import { dummyProduct } from "../../consts/products";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state?.rootReducer?.appearanceSettings || {},
  };
};

class ProductPricing extends React.Component {
  constructor(props) {
    super(props);
  }
  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initPrice = () => {
    const priceFont = this.props.settings["body_font"]?.fontFamily || null;
    const oldPriceColor = this.props.settings["old_price_color"]?.color || null;
    const newPriceColor = this.props.settings["price_color"]?.color || null;
    const priceLabelColor = this.props.settings["body_color"]?.color || null;

    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const productPricingSettings =
      (payload && payload.datas && payload.datas.productPricingSettings) || {};
    const { showInline } = (payload && payload.datas) || {};
    const { alignment } = (payload && payload.settings) || {};

    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(payload, "text", "body");

    const oldPriceCSS = {
      color: productPricingSettings.oldPriceColor || oldPriceColor || null,
      fontFamily:
        productPricingSettings.oldPriceFontFamily || priceFont || null,
      fontWeight: productPricingSettings.oldPriceFontWeight || null,
      fontSize: productPricingSettings.oldPriceFontSize || null,
      fontStyle: productPricingSettings.oldPriceFontStyle || null,
      letterSpacing: productPricingSettings.oldPriceLetterSpacing || null,
    };

    const currentPriceCSS = {
      color: productPricingSettings.currentPriceColor || newPriceColor || null,
      fontFamily:
        productPricingSettings.currentPriceFontFamily || priceFont || null,
      fontWeight: productPricingSettings.currentPriceFontWeight || null,
      fontSize: productPricingSettings.currentPriceFontSize || null,
      fontStyle: productPricingSettings.currentPriceFontStyle || null,
      letterSpacing: productPricingSettings.currentPriceLetterSpacing || null,
    };

    const oldPriceLabelCSS = {
      color:
        productPricingSettings.oldPriceLabelColor || priceLabelColor || null,
      fontFamily:
        productPricingSettings.oldPriceLabelFontFamily || priceFont || null,
      fontWeight: productPricingSettings.oldPriceLabelFontWeight || null,
      fontSize: productPricingSettings.oldPriceLabelFontSize || null,
      fontStyle: productPricingSettings.oldPriceLabelFontStyle || null,
      letterSpacing: productPricingSettings.oldPriceLabelLetterSpacing || null,
    };

    const currentPriceLabelCSS = {
      color:
        productPricingSettings.currentPriceLabelColor ||
        priceLabelColor ||
        null,
      fontFamily:
        productPricingSettings.currentPriceLabelFontFamily || priceFont || null,
      fontWeight: productPricingSettings.currentPriceLabelFontWeight || null,
      fontSize: productPricingSettings.currentPriceLabelFontSize || null,
      fontStyle: productPricingSettings.currentPriceLabelFontStyle || null,
      letterSpacing:
        productPricingSettings.currentPriceLabelLetterSpacing || null,
    };

    const inlineCss = {};

    if (showInline) {
      inlineCss.display = "inline-block";
      inlineCss.marginRight = 10;
    }

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col
            xs={12}
            className="fullcol price-block"
            style={{ textAlign: alignment, ...cssSettingsText }}
          >
            {dummyProduct.price["old-price"] &&
              dummyProduct.price["old-price"] !==
                dummyProduct.price["reduced-price"] && (
                <span style={inlineCss}>
                  <span style={oldPriceLabelCSS}>
                    {(productPricingSettings &&
                      (productPricingSettings[
                        "labelBeforeOldPrice_" + this.props.currentLang
                      ] ||
                        productPricingSettings.labelBeforeOldPrice)) ||
                      ""}
                  </span>{" "}
                  <span className="old-price" style={oldPriceCSS}>
                    {dummyProduct.price["old-price"]}
                  </span>
                </span>
              )}
            {dummyProduct.price["reduced-price"] && (
              <span style={inlineCss}>
                <span style={currentPriceLabelCSS}>
                  {(productPricingSettings &&
                    (productPricingSettings[
                      "labelBeforeCurrentPrice_" + this.props.currentLang
                    ] ||
                      productPricingSettings.labelBeforeCurrentPrice)) ||
                    ""}
                </span>{" "}
                <span className="reduced-price" style={currentPriceCSS}>
                  {dummyProduct.price["reduced-price"]}
                </span>
              </span>
            )}
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className="added">{l("Added")}</span>) || (
              <span className="required">{l("Required")}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initPrice()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initPrice()}
      </Draggable>
    );
  }
}

ProductPricing.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductPricing);
